
  import { Component, Watch, Vue } from 'vue-property-decorator';
  import settings from './config';
  
  @Component
  export default class FbActivation extends Vue {
    public stepList = [];
    public translationSection: string = '';

    public created() {
      this.stepList = this.$route.meta.stepper;
      this.translationSection = settings.VUE_APP_TRANSLATION_SECTION;
    }

    @Watch('$route')
    public onRouteChanged() {
      this.stepList = this.$route.meta.stepper;
    }
  }
